import { MlsPartsFragment, SingleMlsMonthlyStats } from '@cma/generated/graphql'

export type Status = 'complete' | 'invited' | 'notSetup' | 'onboarding'
export type SortDir = 'asc' | 'desc'
export enum StatusFilter {
  'all',
  'complete',
  'invited',
  'notSetup',
  'onboarding'
}

export function prettyStatus(status: StatusFilter) {
  switch (status) {
    case StatusFilter.all:
      return 'All'
    case StatusFilter.notSetup:
      return 'Not Setup'
    case StatusFilter.invited:
      return 'Invited'
    case StatusFilter.onboarding:
      return 'Onboarding'
    case StatusFilter.complete:
      return 'Complete'
  }
}

export enum MonthAbbreviations {
  January = 'Jan',
  February = 'Feb',
  March = 'Mar',
  April = 'Apr',
  May = 'May',
  June = 'Jun',
  July = 'July',
  August = 'Aug',
  September = 'Sept',
  October = 'Oct',
  November = 'Nov',
  December = 'Dec'
}

export type MonthStats = Omit<SingleMlsMonthlyStats, 'mls' | 'month'>
export type Month = keyof typeof MonthAbbreviations

const months: Month[] = Object.keys(MonthAbbreviations) as Month[]

export function getCurrentMonth() {
  return months[new Date().getMonth()]
}

export function getPastMonths() {
  const currentMonth = new Date().getMonth()
  let index = currentMonth
  const pastMonths: Month[] = []
  while (pastMonths.length !== 12) {
    pastMonths.push(months[(index + months.length) % months.length])
    index -= 1
  }
  return pastMonths.reverse()
}

export function getAllMlses(stats?: SingleMlsMonthlyStats[]) {
  return Object.values(
    (stats || []).reduce<Record<string, MlsPartsFragment>>((byMls, data) => {
      if (data.mls.key) {
        return { ...byMls, [data.mls.key]: data.mls }
      }
      return byMls
    }, {})
  )
}

export function getStatsByMonth(
  stats: SingleMlsMonthlyStats[] | undefined,
  selectedMlses: string[]
) {
  return (stats || [])
    .filter((data) =>
      data.mls.key ? selectedMlses.includes(data.mls.key) : false
    )
    .reduce<Record<string, MonthStats | undefined>>((byMonth, stats) => {
      const month: MonthStats = byMonth[stats.month] || {
        totalUsers: 0,
        totalActiveUsers: 0,
        cmaActiveUsers: 0,
        flyerActiveUsers: 0,
        buyerActiveUsers: 0,
        propertyActiveUsers: 0,
        homebeatActiveUsers: 0
      }
      return {
        ...byMonth,
        [stats.month]: {
          totalUsers: month.totalUsers
            ? month.totalUsers + stats.totalUsers
            : stats.totalUsers,
          totalActiveUsers: month.totalActiveUsers
            ? month.totalActiveUsers + stats.totalActiveUsers
            : stats.totalActiveUsers,
          cmaActiveUsers: month.cmaActiveUsers
            ? month.cmaActiveUsers + stats.cmaActiveUsers
            : stats.cmaActiveUsers,
          flyerActiveUsers: month.flyerActiveUsers
            ? month.flyerActiveUsers + stats.flyerActiveUsers
            : stats.flyerActiveUsers,
          buyerActiveUsers: month.buyerActiveUsers
            ? month.buyerActiveUsers + stats.buyerActiveUsers
            : stats.buyerActiveUsers,
          propertyActiveUsers: month.propertyActiveUsers
            ? month.propertyActiveUsers + stats.propertyActiveUsers
            : stats.propertyActiveUsers,
          homebeatActiveUsers: month.homebeatActiveUsers
            ? month.homebeatActiveUsers + stats.homebeatActiveUsers
            : stats.homebeatActiveUsers
        }
      }
    }, {})
}
